// Suppress noise from browser extensions (e.g. MetaMask) injecting into the page.
// The Fin Desk uses no web3/MetaMask code; these errors originate in chrome-extension
// scripts and would otherwise trigger the dev error overlay and block the preview.
function isExtensionNoise(text) {
  if (!text) return false;
  const t = String(text);
  return (
    t.includes("chrome-extension://") ||
    t.includes("moz-extension://") ||
    t.includes("inpage.js") ||
    t.includes("MetaMask") ||
    t.includes("BraveWallet") ||
    t.includes("coinbaseWalletExtension") ||
    t.includes("ethereum")
  );
}

window.addEventListener(
  "unhandledrejection",
  (e) => {
    const reason = e && e.reason;
    const text = (reason && (reason.stack || reason.message)) || String(reason || "");
    if (isExtensionNoise(text)) {
      e.preventDefault();
      e.stopImmediatePropagation && e.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener(
  "error",
  (e) => {
    const src = (e && e.filename) || "";
    const stack = (e && e.error && e.error.stack) || "";
    const msg = (e && e.message) || "";
    if (isExtensionNoise(src) || isExtensionNoise(stack) || isExtensionNoise(msg)) {
      e.preventDefault();
      e.stopImmediatePropagation && e.stopImmediatePropagation();
    }
  },
  true
);
